import { ApplicationFieldEnum as ApplicationFields } from 'Common/FieldEnum';
import { HMREnum } from 'Common/Constants/Enumeration/HMREnum';

export const CustomMemberFields = {
  DifferingProperties: 'DifferingProperties',
  IncomingHOHId: ApplicationFields.IncomingHOHId,
};

export const IncomeComparisonFields = [
  ApplicationFields.Freq1,
  ApplicationFields.Freq2,
  ApplicationFields.Freq3,
  ApplicationFields.Freq4,
  ApplicationFields.Income1,
  ApplicationFields.Income2,
  ApplicationFields.Income3,
  ApplicationFields.Income4,
];

export const FHMRZToHMRCategory = {
  H: HMREnum.Homeless,
  M: HMREnum.Migrant,
  R: HMREnum.Runaway,
};



// WEBPACK FOOTER //
// ./src/pages/reviewincomingapplications/helpers/Constants.js